// extracted by mini-css-extract-plugin
export default {"root":"TrustSeals_root__dKpuq","badgeLink":"TrustSeals_badgeLink__N-wzA","badge":"TrustSeals_badge__lidXf"};